import {openDB} from "idb";

class IndexedDBStorage {
    constructor(name, storeName) {
        this.name = name;
        this.storeName = storeName;
    }

    async getDB() {
        let name = this.name;
        let storeName = this.storeName;

        return await openDB(name, 1, {
            upgrade(db, oldVersion, newVersion, transaction, event) {
                db.createObjectStore(storeName, {keyPath: 'id'}); // create it
            }
        });
    }

    async _getTransaction() {
        let db = await this.getDB();

        let storeName = this.storeName;
        let tx = db.transaction(storeName, "readwrite");
        return tx.objectStore(storeName);
    }

    async set(key, value, expire_seconds = 0) {
        let txItem = await this._getTransaction();

        let now = Date.now();

        let data = {
            id: key,
            value: value,
            expires: expire_seconds > 0 ? now + (expire_seconds * 1000) : null
        };

        await txItem.put(data);
    }

    async get(key) {
        let txItem = await this._getTransaction();
        let item = await txItem.get(key);

        let value = null;
        if (item !== undefined && item !== null) {
            if (item.expires === null || item.expires === undefined)
                value = item.value;
            else {
                let now = Date.now();
                if (now < item.expires)
                    //Not expired, return
                    value = item.value;
                else
                    //Erase expired item
                    await txItem.delete(key);
            }
        }

        return value;
    }
}

export default await new IndexedDBStorage(
    process.env.VUE_APP_INDEXEDDB_NAME,
    process.env.VUE_APP_INDEXEDDB_STORE
);
